import { render, staticRenderFns } from "./PersonalForm.vue?vue&type=template&id=0d345fe4&scoped=true"
import script from "./PersonalForm.vue?vue&type=script&lang=js"
export * from "./PersonalForm.vue?vue&type=script&lang=js"
import style0 from "./PersonalForm.vue?vue&type=style&index=0&id=0d345fe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d345fe4",
  null
  
)

export default component.exports